import { render } from "./Pagination1.vue?vue&type=template&id=4b319912"
import script from "./Pagination1.vue?vue&type=script&lang=js"
export * from "./Pagination1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__